(() => {
  const money = cents => `GH₵${new Intl.NumberFormat('en-GH', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(cents / 100)}`;
  class GhanaOrder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const permitted = JSON.parse(this.querySelector('[data-allowed-variants]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent).filter(variant => !permitted || permitted.map(String).includes(String(variant.id))).map(variant => ({...variant, price: Math.round(variant.price * Number(this.dataset.rate))}));
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.variants = this.variants.map(variant => ({...variant, displayTitle: variant.title === 'Default Title' ? this.labels.standard : variant.title}));
      this.select = this.querySelector('[data-variant]');
      this.quantity = this.querySelector('[data-quantity]');
      this.link = this.querySelector('[data-order-link]');
      this.referrals = window.ghanaReferrals;
      this.referralInput = this.querySelector('[data-referral-code]');
      this.referralStatus = this.querySelector('[data-referral-status]');
      this.referralInput.value = this.referrals?.getCode() || '';
      this.referralInput.addEventListener('input', () => {
        this.requestId = null;
        this.update(false);
      });
      this.referralInput.addEventListener('change', () => this.checkReferral());
      if (this.referralInput.value) this.checkReferral();
      const selected = new URL(location.href).searchParams.get('variant') || this.dataset.selected;
      this.select.replaceChildren(...this.variants.map(variant => {
        const option = new Option(`${variant.displayTitle} — ${money(variant.price)}${variant.available ? '' : ` (${this.labels.soldOut})`}`, String(variant.id));
        option.selected = String(variant.id) === selected;
        return option;
      }));
      this.select.addEventListener('change', () => {this.requestId = null; this.update(true);});
      this.quantity.addEventListener('input', () => {this.requestId = null; this.update(false);});
      this.link.addEventListener('click', event => {
        this.update(false);
        if (this.link.getAttribute('aria-disabled') === 'true' || !this.quantity.reportValidity()) {
          event.preventDefault();
          return;
        }
        const code = this.referrals?.normalise(this.referralInput.value);
        if (!code) return;
        this.requestId ||= this.referrals.requestId();
        this.update(false);
        const variant = this.variants.find(item => String(item.id) === this.select.value);
        const payload = {
          request_id: this.requestId, referral_code: code,
          product_id: this.dataset.productId, variant_id: String(variant.id),
          product_title: this.dataset.product.slice(0, 200), variant_title: variant.displayTitle.slice(0, 200),
          quantity: Number(this.quantity.value), product_url: this.productUrl,
          quoted_total_ghs: variant.price * Number(this.quantity.value) / 100
        };
        this.referrals.api('enquiry', payload).then(result => {
          if (!result.attributed) this.referralStatus.textContent = this.referrals.labels.invalid;
        }).catch(() => {
          this.referralStatus.textContent = this.referrals.labels.offline;
        });
      });
      this.update(false);
    }
    async checkReferral() {
      const value = this.referralInput.value.trim();
      const code = this.referrals?.normalise(value);
      const labels = this.referrals?.labels || {};
      if (!value) {
        this.referrals?.setCode('');
        this.referralStatus.textContent = labels.code_help || '';
        this.update(false);
        return;
      }
      if (!code) {
        this.referralStatus.textContent = labels.invalid;
        return;
      }
      this.referrals.setCode(code);
      this.referralStatus.textContent = labels.checking;
      try {
        const result = await this.referrals.api('validate', {referral_code: code});
        if (this.referralInput.value.trim().toUpperCase() !== code) return;
        this.referralStatus.textContent = result.deferred ? labels.deferred : result.valid ? labels.valid : labels.invalid;
        if (result.valid === false) this.referrals.setCode('');
      } catch {
        this.referralStatus.textContent = labels.offline;
      }
      this.update(false);
    }
    update(updateUrl) {
      const variant = this.variants.find(item => String(item.id) === this.select.value);
      const quantity = Number(this.quantity.value);
      const valid = Number.isInteger(quantity) && quantity > 0 && quantity <= 999;
      this.quantity.setCustomValidity(valid ? '' : this.labels.invalidQuantity);
      if (!variant) return;
      const productUrl = new URL(this.dataset.url);
      productUrl.searchParams.set('variant', variant.id);
      const referralCode = this.referrals?.normalise(this.referralInput.value);
      if (referralCode) productUrl.searchParams.set('ref', referralCode);
      const url = productUrl.href;
      this.productUrl = url;
      this.querySelector('[data-unit]').textContent = money(variant.price);
      this.querySelector('[data-total]').textContent = `${this.labels.total}: ${valid ? money(variant.price * quantity) : '—'}`;
      if (updateUrl && this.closest('main')) {
        const current = new URL(location.href);
        current.searchParams.set('variant', variant.id);
        history.replaceState({}, '', current);
      }
      const enabled = valid && variant.available;
      this.link.setAttribute('aria-disabled', String(!enabled));
      if (!enabled) {
        this.link.removeAttribute('href');
        return;
      }
      const sku = variant.sku && variant.sku !== '<none>' ? `SKU: ${variant.sku}` : '';
      const text = [this.labels.greeting, `${this.labels.product}: ${this.dataset.product}`, `${this.labels.variant}: ${variant.displayTitle}`, sku, `${this.labels.quantity}: ${quantity}`, `${this.labels.unit}: ${money(variant.price)}`, `${this.labels.total}: ${money(variant.price * quantity)}`, `${this.labels.url}: ${url}`, referralCode ? `${this.referrals.labels.code_message}: ${referralCode}` : '', this.requestId && referralCode ? `${this.referrals.labels.reference}: ${this.requestId}` : '', this.labels.confirmation].filter(Boolean).join('\n');
      this.link.href = `https://wa.me/${this.dataset.phone}?text=${encodeURIComponent(text)}`;
    }
  }
  if (!customElements.get('ghana-order')) customElements.define('ghana-order', GhanaOrder);
})();

